<!-- Header: title left, timestamp and refresh right -->
<div class="d-flex justify-content-between align-items-center">
    <p class="fw-semibold mb-1">Patronen</p>
    <div class="d-flex align-items-center">
        <span *ngIf="information" class="text-danger small me-2">{{ information }}</span>
        <span *ngIf="data?.time" class="text-secondary small">Stand {{ data?.time | date: 'dd.MM.yyyy H:mm' }}</span>
        <img class="avs-icon-edit ms-2" role="button" height="20" src="assets/icons/arrow-clockwise.svg"
            alt="Aktualisieren" title="Aktualisieren" (click)="load()">
    </div>
</div>
<p *ngIf="isBusy" class="text-secondary small mb-1">{{ busyMessage }}</p>

<!-- Cartridge configuration: toggle left, current values centred, timestamp right; without configuration no inputs at all -->
<div class="mt-2" [class.avs-fuelcell-stale]="!isEditable && !isConfigUnavailable">
    <div class="d-flex align-items-center">
        <div class="d-flex align-items-center avs-fuelcell-header-side">
            <div *ngIf="!isConfigUnavailable; else configUnavailableTitle" class="d-flex align-items-center avs-fuelcell-collapse-toggle"
                role="button" [attr.aria-expanded]="isConfigExpanded" title="Konfiguration ein- oder ausklappen"
                (click)="isConfigExpanded = !isConfigExpanded">
                <img height="12" alt="" [src]="isConfigExpanded ? 'assets/icons/caret-down.svg' : 'assets/icons/caret-right.svg'">
                <span class="ms-1">Konfiguration</span>
            </div>
            <ng-template #configUnavailableTitle><span>Konfiguration</span></ng-template>
        </div>
        <div class="d-flex justify-content-center flex-wrap">
            <span *ngIf="!isConfigUnavailable; else configUnavailableText">{{ configSummary }}</span>
            <ng-template #configUnavailableText>
                <span class="text-secondary">steht nicht zur Verfügung – Softwareupdate erforderlich</span>
            </ng-template>
        </div>
        <div class="d-flex justify-content-end avs-fuelcell-header-side">
            <span *ngIf="data?.cartridgesConfigTime" class="text-secondary small">
                Stand {{ data?.cartridgesConfigTime | date: 'dd.MM.yyyy H:mm' }}</span>
        </div>
    </div>
    <ng-container *ngIf="!isConfigUnavailable">
        <ng-container *ngIf="isConfigExpanded">
            <div class="row mt-1">
                <div class="col-md-6 mb-2" *ngFor="let row of configRows">
                    <div class="avs-fuelcell-port p-2 h-100">
                        <span class="fw-semibold">{{ getPortString(row.portNumber) }}</span>
                        <div class="d-flex flex-wrap align-items-center mt-1">
                            <mat-form-field>
                                <mat-label>Typ</mat-label>
                                <mat-select [(ngModel)]="row.cType" [name]="'cType' + row.portNumber" [disabled]="!isConfigEditable"
                                    (selectionChange)="onConfigChange(row)">
                                    <mat-option *ngFor="let cartridgeType of cartridgeTypes" [value]="cartridgeType.type">
                                        {{ cartridgeType.label }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field class="ms-2" *ngIf="row.cType === CartridgeType.Custom">
                                <mat-label>Kapazität</mat-label>
                                <input matInput type="number" min="1" [max]="maxCapacity" step="1" [(ngModel)]="row.capacity"
                                    [disabled]="!isConfigEditable" (ngModelChange)="isConfigChanged = true">
                                <span matSuffix class="me-2">l</span>
                            </mat-form-field>
                        </div>
                        <span *ngIf="!isCapacityValid(row)" class="text-danger small">Kapazität 1 – {{ maxCapacity }} l erforderlich</span>
                    </div>
                </div>
            </div>
            <div class="text-end">
                <button class="btn btn-outline-success rounded-0" type="button"
                    [disabled]="!isConfigEditable || !isConfigChanged || !isConfigValid"
                    (click)="onSaveConfigClicked()">Speichern</button>
            </div>
        </ng-container>
    </ng-container>
</div>

<!-- Fill levels and active cartridge; with a fuel manager a click selects the cartridge to activate -->
<div class="mt-2" [class.avs-fuelcell-stale]="!isEditable">
    <span [attr.title]="isActivationPossible
        ? 'Die aktive Patrone ist markiert. Klicken auf eine andere Patrone wählt diese zum Aktivieren aus, gesendet wird mit Speichern.'
        : null">Füllstand</span>
    <div class="row mt-1">
        <div class="col-md-6 mb-2" *ngFor="let row of fillRows">
            <div class="avs-fuelcell-port p-2 h-100" [class.avs-fuelcell-port-active]="isSelectedPort(row.portNumber)"
                [class.avs-fuelcell-port-activatable]="isPortSelectable(row.portNumber)"
                [attr.role]="isPortSelectable(row.portNumber) ? 'button' : null"
                [attr.title]="isPortSelectable(row.portNumber) ? getPortString(row.portNumber) + ' zum Aktivieren auswählen' : null"
                (click)="onPortClicked(row.portNumber)">
                <div class="d-flex justify-content-between align-items-center">
                    <span class="fw-semibold">{{ getPortString(row.portNumber) }}</span>
                    <span *ngIf="isSelectedPort(row.portNumber)" class="text-success small">
                        {{ isActivationChanged ? 'Aktivieren' : 'Aktiv' }}</span>
                </div>
                <div class="mt-1" (click)="$event.stopPropagation()">
                    <mat-form-field>
                        <mat-label>Füllstand</mat-label>
                        <input matInput type="number" min="0" max="100" step="1" [(ngModel)]="row.level"
                            [name]="'fillLevel' + row.portNumber" [disabled]="!isEditable">
                        <span matSuffix class="me-2">%</span>
                    </mat-form-field>
                    <span *ngIf="isFillLevelChanged(row) && !isFillLevelValid(row)" class="text-danger small ms-2">
                        Füllstand 0 – 100 % erforderlich</span>
                </div>
            </div>
        </div>
    </div>
    <div class="text-end">
        <button class="btn btn-outline-success rounded-0" type="button"
            [disabled]="!isEditable || !isFillLevelsSendable"
            (click)="onSaveFillLevelsClicked()">Speichern</button>
    </div>
</div>

<!-- External fuel sensor as a sub-section with its own data -->
<div class="mt-2">
    <avs-fuelcell-sensor-settings [target]="target"></avs-fuelcell-sensor-settings>
</div>
